import React from 'react';
import ProcessingQuoteSelectedTutelaLegale from './ProcessingQuoteSelectedTutelaLegale';
import RiskCardSelected from '../Cards/RiskCardSelected';
import {
  RiskButton, RiskButtonRemove, RiskCard, SelectFirstNotice,
} from './v2/ResultSlotCard.styles';

function TutelaLegaleModalButtons({
  quotations, type, userData, processingQuote, riskQuotations, refresh, removeItemFromCart,
}) {
  return (
    <>
      {quotations && quotations[type.id] && (
        <RiskCard
          className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${userData.processing_quotation_id === null
                        && type.id !== 'res_civile'
            ? 'bg-secondary bg-opacity-25'
            : ''
          } ${userData.processing_quotation_id !== null
                            && type.id === 'res_civile'
            ? 'bg-success bg-opacity-25'
            : ''
          } ${riskQuotations && riskQuotations[type.id] !== undefined
            ? 'bg-success bg-opacity-25'
            : ''
          }`}
        >
          <div className="me-auto">
            <h5>
              {type.id === 'res_civile'
                ? quotations[type.id][0]?.sub_product === 'patente_motor'
                  ? 'Tutela Legale Motor'
                  : quotations[type.id][0]?.sub_product === 'vita_privata'
                    ? 'Vita Privata'
                    : quotations[type.id][0]?.product_name
                : type.name}
            </h5>
          </div>
          {processingQuote !== null && type.id === 'res_civile' && (
          <ProcessingQuoteSelectedTutelaLegale
            processingQuote={processingQuote}
            requestInfo={userData}
            refresh={refresh}
          />
          )}

          {riskQuotations
                        && riskQuotations[type.id] !== undefined
                        && riskQuotations[type.id].map((quote, idx) => (
                          <React.Fragment key={idx}>
                            {processingQuote !== null
                                    && processingQuote.company_id !== 2
                                    && type.id === quote.quote_type && (
                                    <div className="col-12 mb-2">
                                      <RiskCardSelected
                                        quote={quote}
                                        insuranceRequest={userData}
                                        type={type}
                                      />
                                    </div>
                            )}
                          </React.Fragment>
                        ))}

          {/* <div className="d-flex justify-content-end ms-auto gap-2">
                            {type.id === 'res_civile' && processingQuote !== null && (
                              <RiskButtonRemove
                                className="btn btn-danger"
                                onClick={() => removeItemFromCart(processingQuote.id)}
                              >
                                Rimuovi
                              </RiskButtonRemove>
                            )}
                            {type.id === 'res_civile' && (
                              <RiskButton
                                className="btn btn-success"
                                data-bs-toggle="modal"
                                data-bs-target={`#${type.id}`}
                              >
                                Aggiungi
                              </RiskButton>
                            )}
                          </div> */}
          <div className="d-flex justify-content-end ms-auto gap-2">
            {riskQuotations
                            && riskQuotations[type.id] !== undefined
                            && riskQuotations[type.id].map((quote, idx) => (
                              <React.Fragment key={idx}>
                                {type.id === quote.quote_type && (
                                <RiskButtonRemove
                                  className="btn btn-danger"
                                  onClick={() => removeItemFromCart(quote.id)}
                                >
                                  Rimuovi
                                </RiskButtonRemove>
                                )}
                              </React.Fragment>
                            ))}

            {riskQuotations
                            && riskQuotations[type.id] === undefined
                            && processingQuote !== null
                            && type.id !== 'res_civile' && (
                            <RiskButton
                              className="btn btn-success"
                              data-bs-toggle="modal"
                              data-bs-target={`#${type.id}`}
                            >
                              Aggiungi
                            </RiskButton>
            )}

            {userData.processing_quotation_id === null
                            && type.id !== 'res_civile' && (
                            <SelectFirstNotice>
                              Seleziona Prima Vita Privata
                            </SelectFirstNotice>
            )}

            {type.id === 'res_civile' && (
            <RiskButton
              className="btn btn-success"
              data-bs-toggle="modal"
              data-bs-target={`#${type.id}`}
            >
              Aggiungi
            </RiskButton>
            )}

            {processingQuote !== null && (
            <>
              {type.id === 'res_civile' && (
              <RiskButtonRemove
                className="btn btn-danger"
                onClick={() => removeItemFromCart(processingQuote.id)}
              >
                Rimuovi
              </RiskButtonRemove>
              )}
            </>
            )}
          </div>
        </RiskCard>
      )}
    </>
  );
}

export default TutelaLegaleModalButtons;
